import React from "react";
import { graphql, Link as GatsbyLink } from "gatsby";
import Link from "../components/Link";
import Layout from "../components/Layout";
import WithI18next from "../components/WithI18next";

const SupportCenterCategoryPage = ({ data, t, pageContext }) => {
  return (
    <Layout
      title={`${data.currentSCArticle.title} | ${t("support.seo.title")}`}
      description={t("support.seo.description")}
    >
      <div className="pt-5">
        <div className="container mb-5">
          <div className="row">
            <div className="col-lg-3">
              <div className="sidebar">
                <ul className="sidebar-menu">
                  {data.sCArticles.edges.map((post, i) => (
                    <li key={`${post.slug}-${i}`}>
                      <GatsbyLink
                        activeClassName="active"
                        to={`../${post.node.slug}/`}
                      >
                        {post.node.title}
                      </GatsbyLink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-9 page-content sc">
              <p className="mb-5 sc-breadcrumb">
                <Link to="/support/">{t("support.supportCenter")}</Link> {">"}{" "}
                <Link to={`/support/${pageContext.subPageSlug}`}>
                  {pageContext.subPageName}
                </Link>{" "}
                {">"} <span>{data.currentSCArticle.title}</span>
              </p>

              <h1
                className="mb-5"
                dangerouslySetInnerHTML={{
                  __html: data.currentSCArticle.title,
                }}
              />
              <div
                dangerouslySetInnerHTML={{
                  __html: data.currentSCArticle.content,
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="cta mt-auto">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center">
              <h2 className="mb-4">{t("support.haveMoreQuestion")}</h2>
              <Link
                role="button"
                to={"/contact-us/"}
                className="btn btn-primary mb-2"
              >
                {t("support.btnContactUs")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default WithI18next()(SupportCenterCategoryPage);

export const query = graphql`
  query (
    $id: Int!
    $catId: Int!
    $wpLocale: String!
    $wpGlobalConfig: String!
  ) {
    currentSCArticle: wpSupportCenterItem(
      databaseId: { eq: $id }
      language: { locale: { eq: $wpLocale } }
    ) {
      title
      content
    }
    sCArticles: allWpSupportCenterItem(
      filter: {
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { in: [$wpGlobalConfig, ".all"] } }
        categories: { nodes: { elemMatch: { databaseId: { in: [$catId] } } } }
      }
    ) {
      edges {
        node {
          title
          slug
        }
      }
    }
  }
`;
